module.exports = __webpack_public_path__ + "img/vat.6b389e7c.svg";